import { render, staticRenderFns } from "./ClientesAdmin.vue?vue&type=template&id=897a39e6&scoped=true&"
import script from "./ClientesAdmin.vue?vue&type=script&lang=js&"
export * from "./ClientesAdmin.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ClientesAdmin.vue?vue&type=style&index=1&id=897a39e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897a39e6",
  null
  
)

export default component.exports